// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"3a13ee33","705":"7cc54b35"}[chunkId] + ".chunk.js";
};